import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ContextService, needsAttorneyFirmSelection } from '@lr/core';

/**
 * Attorney portal: requires at least one firm in context and a selected firm when
 * the user is LegalResourcesAdmin or has access to multiple firm groups.
 */
export const hasFirmCanActivate: CanActivateFn = () => {
  const contextService = inject(ContextService);
  const router = inject(Router);

  if (contextService.isSessionRejected) {
    router.navigate(['/unauthorized'], { replaceUrl: true });
    return false;
  }

  if (contextService.getPermissions() == null) {
    return false;
  }

  const groups = contextService.getFirmGroups();
  if (groups.length === 0) {
    router.navigate(['/access-denied'], { replaceUrl: true });
    return false;
  }

  if (contextService.getSelectedFirm()) {
    return true;
  }

  const roles = contextService.getRoles();
  if (needsAttorneyFirmSelection(roles, groups.length)) {
    router.navigate(['/firm-selection'], { replaceUrl: true });
    return false;
  }

  contextService.setSelectedFirm(groups[0].firmId);
  return true;
};
